import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { SELECTOR } from "../helper/finder"
import { isElement, isParalelTransmission, isRedundantTransmission, isSerialTransmission } from "../helper/validator"
import { handleElement, handleRedundant, handleParalel } from '.'

export function handleSerial(current: IRBDItem, prev: IRBDItem | undefined): IDiagramValues[] {
    const result: IDiagramValues[] = []
    const elements = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)

    if (!Array.isArray(elements)) {
        return result
    }

    elements.forEach((item, index) => {
        const chainPrev = index === 0 ? prev : elements[index - 1]

        if (isElement(item)) {
            result.push(handleElement(item, chainPrev))
        } else if (isRedundantTransmission(item)) {
            result.push(...handleRedundant(item, chainPrev))
        } else if (isSerialTransmission(item)) {
            result.push(...handleSerial(item, chainPrev))
        } else if (isParalelTransmission(item)) {
            result.push(...handleParalel(item, chainPrev))
        }
    })

    return result
}
